import { SLIDESHOW_DEFAULTS } from './slideshowDefaults';

const BASE = 1920;

/**
 * Returns the watermark canvas dimensions for a given slideshow aspect ratio.
 * The longer axis is fixed at 1920px so watermark positioning is correct at any aspect ratio.
 */
export function getWatermarkCanvasDimensions(aspectRatio?: string | null): {
    width: number;
    height: number;
} {
    const [w, h] = (aspectRatio ?? SLIDESHOW_DEFAULTS.aspectRatio).split(':').map(Number);

    return {
        width: w >= h ? BASE : Math.round((BASE * w) / h),
        height: w >= h ? Math.round((BASE * h) / w) : BASE
    };
}
